import styled from "styled-components";

export const Temp = styled.div.attrs({})``;

export const PageTitle = styled.div.attrs({
  className: "font-medium text-xl",
})`
  color: var(--main-purple-light);
`;

export const FormArea = styled.div.attrs({})`
  padding-top: 2rem;
`;

export const Row = styled.div.attrs({
  className: "lg:flex  mb-3",
})``;
